// extracted by mini-css-extract-plugin
export default {"item":"info-order_item__2BLs7"};